import { Report } from 'interfaces/report'
import { Dispatch } from 'redux'
import { ReportActionType } from "../action-types/reportTypes"
import { Action } from '../actions/reportActions'
import { PaginatedModel } from 'interfaces/pagination'

// export const listReports = (reports: Report[]) => {
//     return (dispatch: Dispatch<Action>) => {
//         dispatch({
//             type: ReportActionType.LIST,
//             payload: reports
//         })
//     }
// }

export const listLastReports = (reports: Report[]) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ReportActionType.LIST_LAST,
            payload: reports
        })
    }
}

export const paginateReports = (data: PaginatedModel<Report>) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ReportActionType.PAGINATE,
            payload: data
        })
    }
}

export const createReport = (report: Report) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ReportActionType.CREATE,
            payload: report
        })
    }
}

export const updateReport = (report: Report) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ReportActionType.UPDATE,
            payload: report
        })
    }
}